export const LGEP_SITE_ID = 1012;
export const FRICHTI_SITE_ID = 1013;
export const FRICHTICO_SITE_ID = 1015;
